const nav = document.querySelector('.custom-nav__list');
const hoverBorder = document.querySelector('.custom-nav__hover-border');
const navItems = document.querySelectorAll('.custom-nav__item');
const navLinks = document.querySelectorAll('.custom-nav__link');
const header = document.querySelector('.custom-header');
let activeDropdownItem = null;
let activeDropdown = null;
let lastScrollY = 0;
let isScrollingDown = false;
let scrollTimeout;

function updateOvalBorder(item) {
  const link = item.querySelector('.custom-nav__link');
  if (!link) return;

  const rect = link.getBoundingClientRect();
  const navRect = nav.getBoundingClientRect();

  const linkCenterX = rect.left - navRect.left + rect.width / 2;
  const linkCenterY = rect.top - navRect.top + rect.height / 2;

  const ovalWidth = rect.width + 20;
  const ovalHeight = 42;
  const borderRadius = ovalHeight;

  hoverBorder.style.width = ovalWidth + 'px';
  hoverBorder.style.height = ovalHeight + 'px';
  hoverBorder.style.borderRadius = borderRadius + 'px';
  hoverBorder.style.left = linkCenterX + 'px';
  hoverBorder.style.top = linkCenterY + 'px';
  hoverBorder.style.opacity = '1';

  hoverBorder.classList.add('active');
}

function hideOvalBorder() {
  if (!activeDropdownItem) {
    hoverBorder.style.opacity = '0';
    hoverBorder.classList.remove('active');
  }
}

function handleLinkTextHover(hoveredLink) {
  nav.classList.add('has-link-hover');
  navLinks.forEach(link => link.classList.remove('is-link-hovered'));
  hoveredLink.classList.add('is-link-hovered');
}

function handleLinkTextLeave() {
  nav.classList.remove('has-link-hover');
  navLinks.forEach(link => link.classList.remove('is-link-hovered'));
}

function handleScroll() {
  const currentScrollY = window.scrollY;

  if (currentScrollY > lastScrollY && currentScrollY > 100) {
    if (!isScrollingDown) {
      isScrollingDown = true;
      header.classList.add('header-hidden');
    }
  } else {
    if (isScrollingDown) {
      isScrollingDown = false;
      header.classList.remove('header-hidden');
    }
  }

  if (currentScrollY > 50) {
    header.classList.add('header-scrolled');
  } else {
    header.classList.remove('header-scrolled');
  }

  lastScrollY = currentScrollY;

  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    if (currentScrollY === 0) {
      header.classList.remove('header-hidden');
    }
  }, 150);
}

const colorElements = document.querySelectorAll('.custom-nav__link, .custom-header__logo a, .glassmorphism-button span, .glassmorphism-button svg, .custom-hamburger, .custom-dropdown__section-title, .custom-dropdown__sub-link');
const helpImage = document.querySelector('.glassmorphism-button--help img');
const dropdownTitles = document.querySelectorAll('.custom-dropdown__section-title');
const dropdownLinks = document.querySelectorAll('.custom-dropdown__sub-link');
const sections = document.querySelectorAll('.section-white');
const logo = document.querySelector('.custom-header__logo a');

const COLORS = {
  dark: 'rgb(50, 50, 50)',
  light: '#FFFFFF'
};

const FILTERS = {
  dark: 'brightness(0) invert(0)',
  light: 'brightness(0) invert(1)'
};

function applyColors(theme) {
  header.style.setProperty('--text-color', COLORS[theme]);
  colorElements.forEach(el => {
    const isSvg = el.tagName.toLowerCase() === 'svg';
    const isHamburger = el.classList.contains('custom-hamburger');
    if (isSvg) {
      el.style.color = COLORS[theme];
      el.style.fill = COLORS[theme];
    } else if (isHamburger) {
      el.style.background = COLORS[theme];
    } else {
      el.style.color = COLORS[theme];
    }
  });
  const dropdownColor = theme === 'light' ? 'rgb(255, 255, 255)' : 'rgb(50, 50, 50)';

  dropdownTitles.forEach(el => {
    el.style.color = dropdownColor;
  });
  
  dropdownLinks.forEach(el => {
    el.style.color = dropdownColor;
  });
  if (helpImage) {
    helpImage.style.filter = FILTERS[theme];
  }
  if (logo) {
    logo.style.filter = FILTERS[theme];
  }
}

function checkHeaderPosition() {
  const isOverWhiteSection = Array.from(sections).some(section => {
    const headerBottom = header.getBoundingClientRect().bottom - 50;
    const sectionStyles = window.getComputedStyle(section);
    const marginTop = parseFloat(sectionStyles.marginTop) || 0;
    const marginBottom = parseFloat(sectionStyles.marginBottom) || 0;
    
    const sectionRect = section.getBoundingClientRect();
    const sectionTop = sectionRect.top - marginTop;
    const sectionBottom = sectionRect.bottom + marginBottom;
    
    return headerBottom >= sectionTop && headerBottom <= sectionBottom;
  });
  
  applyColors(isOverWhiteSection ? 'dark' : 'light');
}

function checkHeaderPositionWithTracking() {
  applyColors('dark');
}

function checkHeaderPositionWithFrcp() {
  applyColors('dark');
}

window.checkHeaderPosition = checkHeaderPosition;
window.checkHeaderPositionWithTracking = checkHeaderPositionWithTracking;
window.checkHeaderPositionWithFrcp = checkHeaderPositionWithFrcp;

document.addEventListener('DOMContentLoaded', function() {
  const dropdowns = document.querySelectorAll('.custom-dropdown');

  dropdowns.forEach((dropdown, index) => {
    const menu = dropdown.querySelector('.custom-dropdown__menu');
    const blur = dropdown.querySelector('.custom-dropdown__blur');
    const content = dropdown.querySelector('.custom-dropdown__content');

    if (menu && blur && content) {
      document.body.appendChild(menu);
      document.body.appendChild(blur);
      
      menu.setAttribute('data-dropdown-id', index);
      blur.setAttribute('data-dropdown-id', index);
      dropdown.setAttribute('data-dropdown-id', index);
    }
  });

  if (nav && hoverBorder && navItems.length) {
    navItems.forEach((item, index) => {
      const dropdown = item.querySelector('.custom-dropdown');
      const link = item.querySelector('.custom-nav__link');

      if (!link) return;

      item.addEventListener('mouseenter', () => {
        handleLinkTextHover(link);
        updateOvalBorder(item);

        if (dropdown) {
          if (activeDropdown && activeDropdown !== dropdown) {
            const oldDropdown = activeDropdown;
            const oldDropdownId = oldDropdown.getAttribute('data-dropdown-id');
            const oldMenu = document.body.querySelector(`.custom-dropdown__menu[data-dropdown-id="${oldDropdownId}"]`);
            const oldBlur = document.body.querySelector(`.custom-dropdown__blur[data-dropdown-id="${oldDropdownId}"]`);
            const oldContent = oldMenu ? oldMenu.querySelector('.custom-dropdown__content') : null;
            
            if (oldMenu && oldBlur && oldContent) {
              oldMenu.classList.remove('custom-dropdown__menu--opening');
              oldBlur.classList.remove('custom-dropdown__blur--opening');
              oldContent.classList.remove('custom-dropdown__content--opening');
              
              oldMenu.classList.add('custom-dropdown__menu--closing');
              oldBlur.classList.add('custom-dropdown__blur--closing');
              oldContent.classList.add('custom-dropdown__content--closing');
              
              const cleanupOldDropdown = () => {
                oldMenu.classList.remove('custom-dropdown__menu--closing');
                oldBlur.classList.remove('custom-dropdown__blur--closing');
                oldContent.classList.remove('custom-dropdown__content--closing');
                
                oldMenu.removeEventListener('transitionend', cleanupOldDropdown);
                oldBlur.removeEventListener('transitionend', cleanupOldDropdown);
                oldContent.removeEventListener('transitionend', cleanupOldDropdown);
              };
              
              oldMenu.addEventListener('transitionend', cleanupOldDropdown);
              oldBlur.addEventListener('transitionend', cleanupOldDropdown);
              oldContent.addEventListener('transitionend', cleanupOldDropdown);
            }
          } else if (activeDropdown === dropdown) {
            return;
          }
          
          openDropdown(dropdown);
        } else {
          if (activeDropdown) {
            closeDropdown(activeDropdown);
          }
        }
      });
    });

    nav.addEventListener('mouseleave', () => {
      handleLinkTextLeave();
      hideOvalBorder();
    });
  }

  dropdowns.forEach((dropdown, index) => {
    const menu = document.body.querySelector(`.custom-dropdown__menu[data-dropdown-id="${index}"]`);

    if (menu) {
      menu.addEventListener('mouseenter', () => {
        if (activeDropdown && activeDropdown !== dropdown) {
          closeDropdown(activeDropdown);
        }
        openDropdown(dropdown);
      });

      menu.addEventListener('mouseleave', (event) => {
        const relatedTarget = event.relatedTarget;
        if (!relatedTarget || (!dropdown.contains(relatedTarget) && !menu.contains(relatedTarget))) {
          closeDropdown(dropdown);
        }
      });

             const content = menu.querySelector('.custom-dropdown__content');
       if (content) {
         content.addEventListener('mouseleave', (event) => {
           const relatedTarget = event.relatedTarget;
           if (!relatedTarget || (!menu.contains(relatedTarget) && !dropdown.contains(relatedTarget))) {
             closeDropdown(dropdown);
           }
         });
       }

       const blur = document.body.querySelector(`.custom-dropdown__blur[data-dropdown-id="${index}"]`);
       if (blur) {
         blur.addEventListener('mouseenter', () => {
           closeDropdown(dropdown);
         });
       }
    }
  });

  document.addEventListener('click', (event) => {
    if (activeDropdown) {
      const dropdown = activeDropdown;
      const dropdownId = dropdown.getAttribute('data-dropdown-id');
      const menu = document.body.querySelector(`.custom-dropdown__menu[data-dropdown-id="${dropdownId}"]`);
      const content = menu ? menu.querySelector('.custom-dropdown__content') : null;
      
      if (!content || !content.contains(event.target)) {
        closeDropdown(dropdown);
      }
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && activeDropdown) {
      closeDropdown(activeDropdown);
    }
  });

  window.addEventListener('scroll', () => {
    if (activeDropdown) {
      closeDropdown(activeDropdown);
    }
    handleScroll();
    
    const trackingApp = document.getElementById('pp-tracking-page-app');
    const frcpApp = document.querySelector('.frcp-app');
    const frcpMain = document.querySelector('main.anchor.frcp-app-parent');
    
    if (trackingApp) {
      checkHeaderPositionWithTracking();
    } else if (frcpApp || frcpMain) {
      checkHeaderPositionWithFrcp();
    } else {
      checkHeaderPosition();
    }
  }, { passive: true });

  checkHeaderPosition();
  
  const shopifySection = document.querySelectorAll(".shopify-section");
  shopifySection.forEach((section) => {
    if (section.classList.contains(".shopify-section--slideshow")) {
      return;
    }
    section.classList.add("section-white");
  });
});

function openDropdown(dropdown) {
  const dropdownId = dropdown.getAttribute('data-dropdown-id');
  const menu = document.body.querySelector(`.custom-dropdown__menu[data-dropdown-id="${dropdownId}"]`);
  const blur = document.body.querySelector(`.custom-dropdown__blur[data-dropdown-id="${dropdownId}"]`);
  const content = menu ? menu.querySelector('.custom-dropdown__content') : null;

  if (!menu || !blur || !content) {
    return;
  }

  activeDropdown = dropdown;
  activeDropdownItem = dropdown.closest('.custom-nav__item');
  document.body.classList.remove('dropdown-hidden');

  if (activeDropdownItem && hoverBorder) {
    updateOvalBorder(activeDropdownItem);
  }

  menu.classList.remove('custom-dropdown__menu--closing');
  blur.classList.remove('custom-dropdown__blur--closing');
  content.classList.remove('custom-dropdown__content--closing');

  menu.classList.add('custom-dropdown__menu--opening');
  blur.classList.add('custom-dropdown__blur--opening');
  content.classList.add('custom-dropdown__content--opening');
}

function closeDropdown(dropdown) {
  const dropdownId = dropdown.getAttribute('data-dropdown-id');
  const menu = document.body.querySelector(`.custom-dropdown__menu[data-dropdown-id="${dropdownId}"]`);
  const blur = document.body.querySelector(`.custom-dropdown__blur[data-dropdown-id="${dropdownId}"]`);
  const content = menu ? menu.querySelector('.custom-dropdown__content') : null;

  if (!menu || !blur || !content) {
    return;
  }

  menu.classList.add('custom-dropdown__menu--closing');
  blur.classList.add('custom-dropdown__blur--closing');
  content.classList.add('custom-dropdown__content--closing');

  menu.classList.remove('custom-dropdown__menu--opening');
  blur.classList.remove('custom-dropdown__blur--opening');
  content.classList.remove('custom-dropdown__content--opening');

  const cleanupDropdown = () => {
    menu.classList.remove('custom-dropdown__menu--closing');
    blur.classList.remove('custom-dropdown__blur--closing');
    content.classList.remove('custom-dropdown__content--closing');
    
    if (!activeDropdown) {
      document.body.classList.add('dropdown-hidden');
    }
    
    menu.removeEventListener('transitionend', cleanupDropdown);
    blur.removeEventListener('transitionend', cleanupDropdown);
    content.removeEventListener('transitionend', cleanupDropdown);
  };
  
  menu.addEventListener('transitionend', cleanupDropdown);
  blur.addEventListener('transitionend', cleanupDropdown);
  content.addEventListener('transitionend', cleanupDropdown);

  activeDropdown = null;
  activeDropdownItem = null;
  
  const currentHoveredItem = document.querySelector('.custom-nav__item:hover');
  if (!currentHoveredItem) {
    if (hoverBorder) {
      hoverBorder.style.opacity = '0';
      hoverBorder.classList.remove('active');
    }
  }
}

const allSections = document.querySelectorAll('section');

allSections.forEach(section => {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const backgroundColor = getComputedStyle(entry.target).backgroundColor;
        const rgbValues = backgroundColor.match(/\d+/g);
        
        if (rgbValues && rgbValues.length >= 3) {
          const r = parseInt(rgbValues[0]);
          const g = parseInt(rgbValues[1]);
          const b = parseInt(rgbValues[2]);
          const brightness = (r * 299 + g * 587 + b * 114) / 1000;
          
          if (brightness > 128) {
            document.body.classList.add('section-white');
          } else {
            document.body.classList.remove('section-white');
          }
        }
      }
    });
  }, { threshold: 0.1 });

  observer.observe(section);
});

document.addEventListener('DOMContentLoaded', function() {
  const allSections = document.querySelectorAll('section');
  allSections.forEach(section => {
    section.classList.add("section-white");
  });
});